export default "__VITE_ASSET__CKgdtEn5__"